export default __webpack_public_path__ + "static/media/oscer-pres-breast-lump.56f9733d.svg";